import withClassName from '../../utils/withClassName';
import styles from './PageBreakBox.scss';

export default withClassName(styles.pageBreakContainer)('div');
